import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './pages/Home'

import Navbar from './compenents/Navbar'
import Footer from './compenents/Footer'
import Products from './pages/Products'
import Properties from './pages/Properties'
import Technical from './pages/Technical'
import Application from './pages/Application'
import Industries from './pages/Industries'
import Contact from './pages/Contact'
import ScrollToTop from './compenents/ScrollToTop '


function App() {
  return (
    <Router>
      <ScrollToTop/>
      <div className="min-h-screen bg-gradient-to-b from-green-50 to-white">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/technical" element={<Technical />} />
          <Route path="/application" element={<Application />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  )
}

export default App